import { render } from "./ImportaSottoprogetto.vue?vue&type=template&id=b0f8c596&ts=true"
import script from "./ImportaSottoprogetto.vue?vue&type=script&lang=ts"
export * from "./ImportaSottoprogetto.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__